export const inspirations = [
    {
        title:"mailchimp presents",
        desc1:"Podcasts",
        desc2:"Series",
        desc3:"Films"
    },{
        title:"Courier",
        desc1:"Expert Insights",
        desc2:"Industry Trends",
        desc3:"Smart Living"
    }
]